module.exports = __webpack_public_path__ + "img/relaxation.37d2953c.png";